var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "neu-cards-ctn", attrs: { cols: "1", "cols-xl": "4" } },
    [
      _vm._l(_vm.blocks, function(block) {
        return _c("PatientPanelServiceBlock", {
          key: block.path,
          attrs: {
            id: block.id,
            visible: !block.invisible,
            title: block.title,
            img: block.img,
            path: block.path,
            soonLabel: block.soonLabel,
            action: block.action,
            backgroundColor: block.backgroundColor,
            textAndIconColor: block.textAndIconColor,
            description: block.description
          },
          scopedSlots: _vm._u(
            [
              block.showOptionsBtn
                ? {
                    key: "absolute-items",
                    fn: function() {
                      return [
                        _c("b-icon-gear", {
                          staticClass: "history-gear-options mb-1",
                          attrs: {
                            id: "showHistoryOptions" + block.id,
                            scale: "1.3"
                          },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "b-popover",
                          {
                            attrs: {
                              target: "showHistoryOptions" + block.id,
                              triggers: "click blur",
                              placement: "bottom"
                            }
                          },
                          [
                            _c(
                              "b-row",
                              [
                                (_vm.$store.state.session.user
                                ? _vm.$store.state.session.user.havePets
                                : false)
                                  ? _c(
                                      "b-col",
                                      {
                                        attrs: { cols: "12" },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.petSelected(block.path)
                                          }
                                        }
                                      },
                                      [
                                        _c("div", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "clinic-history.selectPet"
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.showGrantAccessBlock(block.id)
                                  ? _c(
                                      "b-col",
                                      {
                                        attrs: { cols: "12" },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            _vm.showGrantAccessHistoryModal = true
                                          }
                                        }
                                      },
                                      [
                                        _c("div", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "clinic-history.grant-access"
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.showProfAndCenterAuthorizedBlock(block.id)
                                  ? _c(
                                      "b-col",
                                      {
                                        attrs: { cols: "12" },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            _vm.showProfAndCenterAuthorizedModal = true
                                          }
                                        }
                                      },
                                      [
                                        _c("div", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "clinic-history.access-authorizated"
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    },
                    proxy: true
                  }
                : null
            ],
            null,
            true
          )
        })
      }),
      _vm._v(" "),
      _c("history-prof-and-center-authorized", {
        model: {
          value: _vm.showProfAndCenterAuthorizedModal,
          callback: function($$v) {
            _vm.showProfAndCenterAuthorizedModal = $$v
          },
          expression: "showProfAndCenterAuthorizedModal"
        }
      }),
      _vm._v(" "),
      _c("change-pet-modal", {
        attrs: { path: _vm.petsPath },
        model: {
          value: _vm.changePetModalVisible,
          callback: function($$v) {
            _vm.changePetModalVisible = $$v
          },
          expression: "changePetModalVisible"
        }
      }),
      _vm._v(" "),
      _c("history-grant-access", {
        attrs: { id: _vm.userToGrantAccess },
        model: {
          value: _vm.showGrantAccessHistoryModal,
          callback: function($$v) {
            _vm.showGrantAccessHistoryModal = $$v
          },
          expression: "showGrantAccessHistoryModal"
        }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bea923b2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bea923b2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/clinicHistory/ClinicHistoryMenu.vue
// module id = 4043
// module chunks = 73